import { render } from "./ProductOffers.vue?vue&type=template&id=75857da2"
import script from "./ProductOffers.vue?vue&type=script&lang=js"
export * from "./ProductOffers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__